module.exports = __webpack_public_path__ + "img/accessibility.0039589e.svg";